import moment from "moment/moment";

export default function (
  posOrderListData,
  posOrderAmountField,
  posOrderCountField,
  posDateField,
  posTypeField,
  onlineOrderListData,
  onlineOrderAmountField,
  onlineOrderCountField,
  onlineDateField,
  onlineTypeField,
  minCol = 12
) {
  const posOrderList = posOrderListData || [];
  const onlineOrderList = onlineOrderListData || [];
  let labels = [];
  const datasets = [
    {
      label: "POS Product",
      fill: true,
      borderRadius: 4,
      borderColor: "#2DDF89",
      backgroundColor: "#2DDF89",
      pointBorderColor: "#2916F5",
      borderWidth: 3,
      data: [],
      stack: "stack 0",
    },
    // {
    //   label: "Order Count",
    //   fill: true,
    //   borderRadius: 4,
    //   borderColor: "#2DDFAA",
    //   backgroundColor: "#2DDFAA",
    //   pointBorderColor: "#2916AA",
    //   borderWidth: 3,
    //   data: [],
    //   // hidden: true,
    //   // stack: "stack 0",
    // },
    {
      label: "POS Service",
      fill: true,
      borderRadius: 4,
      borderColor: "#EC4E0F",
      backgroundColor: "#EC4E0F",
      pointBorderColor: "#EC4E0F",
      borderWidth: 3,
      data: [],
      stack: "stack 0",
    },
    // {
    //   label: "Order Count",
    //   fill: true,
    //   borderRadius: 4,
    //   borderColor: "#EC4E0F",
    //   backgroundColor: "#EC4E0F",
    //   pointBorderColor: "#EC4E0F",
    //   borderWidth: 3,
    //   data: [],
    //   // hidden: true,
    //   // stack: "stack 0",
    // },
    {
      label: "Online Product",
      fill: true,
      borderRadius: 4,
      borderColor: "#002872",
      backgroundColor: "#002872",
      pointBorderColor: "#002872",
      borderWidth: 3,
      data: [],
      stack: "stack 1",
    },
    {
      label: "Order Count",
      fill: true,
      borderRadius: 4,
      borderColor: "#002872",
      backgroundColor: "#002872",
      pointBorderColor: "#002872",
      borderWidth: 3,
      data: [],
      // hidden: true,
      // stack: "stack 1",
    },
    {
      label: "Online Service",
      fill: true,
      borderRadius: 4,
      borderColor: "#1C1F37",
      backgroundColor: "#1C1F37",
      pointBorderColor: "#1C1F37",
      borderWidth: 3,
      data: [],
      stack: "stack 1",
    },
    {
      label: "Order Count",
      fill: true,
      borderRadius: 4,
      borderColor: "#1C1F37",
      backgroundColor: "#1C1F37",
      pointBorderColor: "#1C1F37",
      borderWidth: 3,
      data: [],
      // hidden: true,
      // stack: "stack 1",
    },
  ];
  if (
    (posOrderList && posOrderList.length > 0) ||
    (onlineOrderList && onlineOrderList.length > 0)
  ) {
    let lastKnownTime = "01-Jan-1900";
    posOrderList.map((x) => {
      labels.push(`${x.date}`);
      lastKnownTime = `${x.date}`;
      if (x.type == "PRODUCT") {
        datasets[0].data.push(+parseFloat(x[posOrderAmountField]).toFixed(2));
        datasets[1].data.push(+parseFloat(x[posOrderCountField]).toFixed(2));
      } else if (x.type == "SERVICE") {
        datasets[1].data.push(+parseFloat(x[posOrderAmountField]).toFixed(2));
        datasets[3].data.push(+parseFloat(x[posOrderCountField]).toFixed(2));
      }
    });
    onlineOrderList.map((y) => {
      labels.push(`${y.date}`);
      lastKnownTime = `${y.date}`;
      if (y.type == "PRODUCT") {
        datasets[2].data.push(
          +parseFloat(y[onlineOrderAmountField]).toFixed(2)
        );
        datasets[3].data.push(+parseFloat(y[onlineOrderCountField]).toFixed(2));
      } else if (y.type == "SERVICE") {
        datasets[4].data.push(
          +parseFloat(y[onlineOrderAmountField]).toFixed(2)
        );
        datasets[5].data.push(+parseFloat(y[onlineOrderCountField]).toFixed(2));
      }
    });
    if (datasets[0].data.length < minCol) {
      lastKnownTime = moment(`${labels}`, "YYYY-MM-DD");
      Array(minCol - datasets[0].data.length)
        .fill(0)
        .map((_, i) => {
          labels.unshift(lastKnownTime.add(-1, "days").format("YYYY-MM-DD"));
          datasets[0].data.unshift(0.0);
        });
    }
    if (datasets[1].data.length < minCol) {
      lastKnownTime = moment(`${labels}`, "YYYY-MM-DD");
      Array(minCol - datasets[1].data.length)
        .fill(0)
        .map((_, i) => {
          datasets[1].data.unshift(0.0);
        });
    }
    if (datasets[2].data.length < minCol) {
      lastKnownTime = moment(`${labels}`, "YYYY-MM-DD");
      Array(minCol - datasets[2].data.length)
        .fill(0)
        .map((_, i) => {
          datasets[2].data.unshift(0.0);
        });
    }
    if (datasets[3].data.length < minCol) {
      lastKnownTime = moment(`${labels}`, "YYYY-MM-DD");
      Array(minCol - datasets[3].data.length)
        .fill(0)
        .map((_, i) => {
          datasets[3].data.unshift(0.0);
        });
    }
  }
  return {
    labels,
    datasets,
  };
}
